import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

/**
 * @deprecated because of buggy. If nested buttons or other action handlers exists,
 *   it can behave unexpected and handle produce additional actions.
 *   Seems like because of onBlur action implemented here
 */
class FieldContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.onBlur = this.onBlur.bind(this);
  }

  onBlur() {
    this.setState({
      hasBlurred: true,
    });
  }

  render() {
    const {
      label: labelText,
      error,
      children,
      className,
      labelClassName,
      labelType,
      errorOnBlur,
      tooltip,
    } = this.props;
    const LabelType = labelType ? labelType : 'label';
    const showError = error && (!errorOnBlur || this.state.hasBlurred);
    const label = labelText && (
      <div className={classNames('field-label-text', labelClassName)}>{labelText}</div>
    );
    return (
      <div className={classNames('field-container', className, {error})} onBlur={this.onBlur}>
        <LabelType className="field-label">
          {tooltip ? (
            <GenericTooltip positionTop delay={TOOLTIP_DELAY} tooltip={tooltip}>
              <span>{label}</span>
            </GenericTooltip>
          ) : (
            label
          )}
          {children}
        </LabelType>
        {showError && <div className="field-error-message">{error}</div>}
      </div>
    );
  }
}

FieldContainer.propTypes = {
  // String to show on the label
  label: PropTypes.any,
  // String to show when there is an error or optionally false for no error
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  // The field component. Must be a single children
  children: PropTypes.node,
  // Extra className for the FieldContainer
  className: PropTypes.string,
  // Only show error on blur
  errorOnBlur: PropTypes.bool,
};

export default FieldContainer;
